import React from 'react';
import { TextInput as RNTextInput } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import {
  getCardBackgroundColor,
  getCardBorderColor,
  getInputBackgroundColor,
  getInputBorderColor,
  CARD_BORDER_RADIUS,
  CARD_PADDING,
  BORDER_RADIUS_SMALL,
  INPUT_PADDING_SMALL,
  INPUT_FONT_SIZE,
  FONT_SIZE_MD,
  BORDER_WIDTH_THIN,
} from '../constants';

export type CardPaymentFormProps = {
  isDark: boolean;
  textColor: string;
  subtextColor: string;
  cardNumber: string;
  cardExpiry: string;
  cardCVC: string;
  cardName: string;
  onCardNumberChange: (text: string) => void;
  onCardExpiryChange: (text: string) => void;
  onCardCVCChange: (text: string) => void;
  onCardNameChange: (text: string) => void;
};

const CardPaymentForm: React.FC<CardPaymentFormProps> = React.memo(({
  isDark,
  textColor,
  subtextColor,
  cardNumber,
  cardExpiry,
  cardCVC,
  cardName,
  onCardNumberChange,
  onCardExpiryChange,
  onCardCVCChange,
  onCardNameChange,
}) => {
  return (
    <YStack
      backgroundColor={getCardBackgroundColor(isDark)}
      borderRadius={CARD_BORDER_RADIUS}
      padding={CARD_PADDING}
      borderWidth={BORDER_WIDTH_THIN}
      borderColor={getCardBorderColor(isDark)}
      space="$3"
    >
      <Text fontSize={FONT_SIZE_MD} fontWeight="600" color={subtextColor}>
        Numer karty
      </Text>
      <RNTextInput
        value={cardNumber}
        onChangeText={(text) => onCardNumberChange(text.replace(/\s/g, ''))}
        placeholder="1234 5678 9012 3456"
        placeholderTextColor={subtextColor}
        keyboardType="number-pad"
        maxLength={16}
        style={{
          backgroundColor: getInputBackgroundColor(isDark),
          borderRadius: BORDER_RADIUS_SMALL,
          padding: INPUT_PADDING_SMALL,
          fontSize: INPUT_FONT_SIZE,
          color: textColor,
          borderWidth: BORDER_WIDTH_THIN,
          borderColor: getInputBorderColor(isDark),
        }}
      />

      <XStack gap="$3">
        <YStack flex={1} space="$2">
          <Text fontSize={FONT_SIZE_MD} fontWeight="600" color={subtextColor}>
            MM/RR
          </Text>
          <RNTextInput
            value={cardExpiry}
            onChangeText={onCardExpiryChange}
            placeholder="12/25"
            placeholderTextColor={subtextColor}
            keyboardType="number-pad"
            maxLength={5}
            style={{
              backgroundColor: getInputBackgroundColor(isDark),
              borderRadius: BORDER_RADIUS_SMALL,
              padding: INPUT_PADDING_SMALL,
              fontSize: INPUT_FONT_SIZE,
              color: textColor,
              borderWidth: BORDER_WIDTH_THIN,
              borderColor: getInputBorderColor(isDark),
            }}
          />
        </YStack>

        <YStack flex={1} space="$2">
          <Text fontSize={FONT_SIZE_MD} fontWeight="600" color={subtextColor}>
            CVC
          </Text>
          <RNTextInput
            value={cardCVC}
            onChangeText={onCardCVCChange}
            placeholder="123"
            placeholderTextColor={subtextColor}
            keyboardType="number-pad"
            maxLength={4}
            secureTextEntry
            style={{
              backgroundColor: getInputBackgroundColor(isDark),
              borderRadius: BORDER_RADIUS_SMALL,
              padding: INPUT_PADDING_SMALL,
              fontSize: INPUT_FONT_SIZE,
              color: textColor,
              borderWidth: BORDER_WIDTH_THIN,
              borderColor: getInputBorderColor(isDark),
            }}
          />
        </YStack>
      </XStack>

      <YStack space="$2">
        <Text fontSize={FONT_SIZE_MD} fontWeight="600" color={subtextColor}>
          Imię i nazwisko
        </Text>
        <RNTextInput
          value={cardName}
          onChangeText={onCardNameChange}
          placeholder="Jan Kowalski"
          placeholderTextColor={subtextColor}
          style={{
            backgroundColor: getInputBackgroundColor(isDark),
            borderRadius: BORDER_RADIUS_SMALL,
            padding: INPUT_PADDING_SMALL,
            fontSize: INPUT_FONT_SIZE,
            color: textColor,
            borderWidth: BORDER_WIDTH_THIN,
            borderColor: getInputBorderColor(isDark),
          }}
        />
      </YStack>
    </YStack>
  );
});

CardPaymentForm.displayName = 'CardPaymentForm';

export default CardPaymentForm;

